import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { TranslateService } from '@ngx-translate/core';
import { IHeader } from 'src/app/core/interfaces/shared/components/client-notification-interfaces';

export enum notifyType {
  Email = 1,
  SMS = 2,
}
@Component({
  selector: 'app-client-notification-card',
  templateUrl: './client-notification-card.component.html',
  styleUrls: ['./client-notification-card.component.scss'],
})
export class ClientNotificationCardComponent implements OnInit {
  header: IHeader;

  translateServiceKey: string = 'client-notification-card';
  sendBtnText: string = '';
  sendMethodText: string = '';

  notifyValueSelected: MatRadioChange;

  notify_types_options = Object.keys(notifyType)
    .filter((key) => isNaN(Number(key)))
    .map((key) => {
      return { alias: key, value: notifyType[key] };
    });

  @Output() emitNotifyType = new EventEmitter<MatRadioChange>();

  constructor(private translateService: TranslateService) {
    this.sendBtnText = this.translateService.instant(
      `${this.translateServiceKey}.sendBtn`
    );
    this.sendMethodText = this.translateService.instant(
      `${this.translateServiceKey}.sendMethod`
    );
  }

  ngOnInit(): void {
    this.setHeaderText();
  }

  setHeaderText() {
    this.header = {
      title: this.translateService.instant(`${this.translateServiceKey}.title`),
      subtitle: this.translateService.instant(
        `${this.translateServiceKey}.subtitle`
      ),
    };
  }

  optionSelected(value) {
    this.notifyValueSelected = value;
  }

  emitNotifyMethod() {
    this.emitNotifyType.emit(this.notifyValueSelected);
  }
}
